module.exports = __webpack_public_path__ + "img/coor2.b3eb7157.png";